import { TOPIC_LINKS } from '@src/constants/topic';
import $$tracker from '@src/tracker';

class TopicHeroStore {
  items = TOPIC_LINKS.map(item => ({
    ...item,
    onClick: () => $$tracker.clickSubFunctionButton(item.title, '首页子功能按钮')
  }));
}

export default TopicHeroStore;
